export default [
  // 平台热点管理列表
  { 
      path: '/HomePageMgt/PlatformHotspotList',
      name:'PlatformHotspotList',
      meta: { title: '平台热点管理列表'},
      component: () => import('../../views/HomePageMgt/PlatformHotspotList.vue')
  },
  // 新增平台热点
  { 
    path: '/HomePageMgt/PlatformHotspotList/add/:type',
    name:'PlatformHotspotListAdd',
    meta: { title: '新增平台热点'},
    component: () => import('../../views/HomePageMgt/PlatformHotspotListAdd.vue')
},
 // 编辑平台热点
 { 
  path: '/HomePageMgt/PlatformHotspotList/edit/:type/:id',
  name:'PlatformHotspotListEdit',
  meta: { title: '编辑平台热点'},
  component: () => import('../../views/HomePageMgt/PlatformHotspotListEdit.vue')
},
  // 融资产品推荐列表
  { 
    path: '/HomePageMgt/RecommendedList',
    name:'RecommendedList',
    meta: { title: '融资产品推荐列表'},
    component: () => import('../../views/HomePageMgt/RecommendedList.vue')
  },
  // 新增融资产品推荐
  { 
    path: '/HomePageMgt/RecommendedList/add',
    name:'RecommendedListAdd',
    meta: { title: '新增融资产品推荐'},
    component: () => import('../../views/HomePageMgt/RecommendedListAdd.vue')
  },
  // 编辑融资产品推荐
  { 
    path: '/HomePageMgt/RecommendedList/edit/:id',
    name:'RecommendedListEdit',
    meta: { title: '编辑融资产品推荐'},
    component: () => import('../../views/HomePageMgt/RecommendedListEdit.vue')
  },
  // 活动推荐列表
  { 
    path: '/HomePageMgt/ActivityList',
    name:'ActivityList',
    meta: { title: '活动推荐列表'},
    component: () => import('../../views/HomePageMgt/ActivityList.vue')
  },
  // 添加活动推荐
  { 
    path: '/HomePageMgt/ActivityList/add',
    name:'ActivityListAdd',
    meta: { title: '添加活动推荐'},
    component: () => import('../../views/HomePageMgt/ActivityListAdd.vue')
  },
   // 编辑活动推荐
   { 
    path: '/HomePageMgt/ActivityList/edit/:id',
    name:'ActivityListEdit',
    meta: { title: '编辑活动推荐'},
    component: () => import('../../views/HomePageMgt/ActivityListEdit.vue')
  },
]